<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop>
      <div class="detail__head">
        <h3 class="detail__head-title">{{ activity.name }}</h3>
        <div class="detail__head-close" @click.stop="closeModal">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L17 17" stroke="#697178" stroke-width="2"/>
            <path d="M1 17L17 1" stroke="#697178" stroke-width="2"/>
          </svg>
        </div>
      </div>

      <div class="modal__body event">
        <div class="event__block margin">
          <span class="event__block-range">
            <div class="range__item">
              <div class="event__item-name">Дата и время начала:</div>
              <div class="event__start">
                <span>{{ activity.start_at ? formatDateTime(activity.start_at) : 'Не назначена' }}</span>
              </div>
            </div>
            <div class="range__item">
              <div class="event__item-name">Дата и время завершения:</div>
              <div class="event__start">
                <span>{{ activity.end_at ? formatDateTime(activity.end_at) : 'Не указана' }}</span>
              </div>
            </div>
          </span>

          <span v-if="currentUser.id === activity.ownerId" class="event__controls">
            <AppButtonSmEdit @click.native="editEvent" />
            <AppButtonSmRemove @click.stop.native="toggleIsVisibleModalRemove" />
            <AppButtonSmRepeat @click.stop.native="toggleIsVisibleModalRepeat"/>
          </span>

        </div>

        <div class="margin" v-if="activity.address">
          <div class="event-place__title event__item-name">Место проведения:</div>
          <div class="post__text" v-html="activity.address" />
        </div>

        <div class="event-description margin" v-if="activity.description">
          <div class="event-description__title event__item-name">Описание:</div>
          <div class="post__text" v-html="activity.description" />
        </div>

        <div class="margin">
          <div class="event__item-name">Участники:</div>
          <p class="event__title" v-if="(activity.departments && activity.departments.length === 0) && (activity.groups && activity.groups.length === 0) && (activity.users && activity.users.length === 0)">Все сотрудники</p>
          <ul class="members-list" v-else>
            <!--участники отделы-->
            <li class="members-list__item" v-for="item in activity.departments" :key="`${item.id}_department`" :title="item.name">
              <div class="user-avatar event-member-avatar">
                <img v-if="item.avatar && item.avatar.file_size"
                     :src="item.avatar.url" :alt="item.name">
                <img v-else src="/img/system-avatar.svg" :alt="item.name">
              </div>
            </li>
            <!--участники группы-->
            <li class="members-list__item" v-for="item in activity.groups" :key="`${item.id}_group`" :title="item.name">
              <div class="user-avatar event-group-avatar" :style="`background: ${item.color}; box-shadow: 0 0 0 2px ${item.color};`">
                <svg width="15" height="10" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.578 3.83416C17.578 5.27849 16.3678 6.44934 14.8749 6.44934C13.382 6.44934 12.1717 5.27849 12.1717 3.83416C12.1717 2.38984 13.382 1.21898 14.8749 1.21898C16.3678 1.21898 17.578 2.38984 17.578 3.83416ZM18.838 3.83416C18.838 5.3158 17.9694 6.60116 16.6978 7.23953C17.8624 7.59073 18.896 8.27178 19.6617 9.19962C20.3529 10.0372 20.793 11.0363 20.9427 12.0882H21V13.3072H12.1045C12.1404 13.4639 12.1697 13.622 12.1924 13.781H12.2497V14.5871V14.5901V15H0V14.5901V13.781H0.0573702C0.128603 13.2811 0.265722 12.7909 0.466228 12.3225C0.774031 11.6036 1.22519 10.9504 1.79393 10.4002C2.36268 9.84993 3.03788 9.41346 3.78098 9.11567C3.95197 9.04715 4.12578 8.98629 4.30187 8.93317C3.03027 8.29483 2.16151 7.00943 2.16151 5.52772C2.16151 3.41017 3.93587 1.69356 6.12466 1.69356C8.31345 1.69356 10.0878 3.41017 10.0878 5.52772C10.0878 7.00937 9.21913 8.29472 7.94761 8.9331C8.12379 8.98623 8.29768 9.04712 8.46876 9.11567C8.89639 9.28704 9.30154 9.50433 9.67685 9.76281C10.2865 8.81627 11.1628 8.05132 12.2088 7.56198C12.4826 7.43388 12.7645 7.32633 13.0521 7.23961C11.7805 6.60126 10.9117 5.31586 10.9117 3.83416C10.9117 1.71661 12.6861 0 14.8749 0C17.0637 0 18.838 1.71661 18.838 3.83416ZM11.677 12.0882H19.7133C19.5733 11.304 19.2309 10.5618 18.7121 9.93304C18.0176 9.09141 17.0481 8.50309 15.9625 8.26457C14.877 8.02604 13.7399 8.15147 12.7378 8.62028C11.8389 9.04079 11.0964 9.71518 10.6059 10.5506C11.0442 11.0057 11.4056 11.5246 11.677 12.0882ZM8.82782 5.52772C8.82782 6.97205 7.61758 8.1429 6.12466 8.1429C4.63175 8.1429 3.4215 6.97205 3.4215 5.52772C3.4215 4.0834 4.63175 2.91254 6.12466 2.91254C7.61758 2.91254 8.82782 4.0834 8.82782 5.52772ZM11.0426 13.781H1.20719C1.26962 13.4259 1.37311 13.0777 1.51629 12.7433C1.76697 12.1578 2.13441 11.6258 2.59761 11.1777C3.06082 10.7296 3.61072 10.3741 4.21593 10.1316C4.82114 9.88903 5.4698 9.7642 6.12487 9.7642C6.77994 9.7642 7.4286 9.88903 8.03381 10.1316C8.63902 10.3741 9.18892 10.7296 9.65213 11.1777C10.1153 11.6258 10.4828 12.1578 10.7335 12.7433C10.8766 13.0777 10.9801 13.4259 11.0426 13.781Z" fill="currentColor"/>
                </svg>
              </div>
            </li>
            <!--участники сотрудники-->
            <li @click="openUserDetail(item.id)" style="cursor: pointer;" class="members-list__item" v-for="item in activity.users" :key="`${item.id}_user`" :title="item.profile.full_name">
              <div class="user-avatar event-member-avatar">
                <img v-if="item.avatar && item.avatar.file_size"
                     :src="item.avatar.url" :alt="item.profile.full_name">
                <img v-else src="/img/avatar-thumb.png" :alt="item.profile.full_name">
              </div>
              <div class="tooltip">
                <transition name="fade">
                  <div class="tooltip__block tooltip__right">
                    {{ item.profile.full_name }}
                  </div>
                </transition>
              </div>
            </li>
          </ul>
        </div>

        <div v-if="false" class="footer">
          <AppCheckbox title="Напоминание"
                      :checked="reminder.toggle"
                      @toggle-check="reminder.toggle = !reminder.toggle"
                      style="margin-bottom: 20px"
          />

          <AppSelect title="Время напоминания"
                      :options="reminder.options"
                      placeholder="Выберите время напоминания"
                      :value="reminder.value"
                      @value-changed="(option) => reminder.value = option"
                      width="100%"
          />

          <div v-if="isMember" class="buttons">
            <AppButton title="Участвовать"
                      type="third"
                      style="margin-right: 8px" />
            <AppButton title="Отказаться"
                      type="alt" />
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <AppConfirmation
        v-if="isVisibleModalRemove"
        text="Вы действительно хотите удалить это мероприятие?"
        @confirm="deleteActivity(activity.id)"
        @reject="toggleIsVisibleModalRemove"
      />
      <BaseModal
        v-if="isVisibleModalRepeat"
        @close="isVisibleModalRepeat = false"
        title="Повторить мероприятие"
        style="max-width: 100%;"
      >
        <ActivityRepeatForm
          style="width: 600px;"
          v-model="repeatFormData"
          @activityRepeatSubmit="activityRepeatSubmit"
          @cancel="isVisibleModalRepeat = false"
        />
<!--        @constructingSubmit="createConstructingSubmit"-->
      </BaseModal>
    </transition>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils/utils'
import AppButtonSmEdit from '@/components/page/button/AppButtonSmEdit'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import AppSelect from '@/components/page/input/AppSelect'
import AppButton from '@/components/page/button/AppButton.vue'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import axios from '@/utils/axios.js'
import { config, url } from '@/store/index'
import AppButtonSmRepeat from '@/components/page/button/AppButtonSmRepeat'
import BaseModal from '@/components/page/modal/base/BaseModal'
import ActivityRepeatForm from '@/components/activity/form/ActivityRepeatForm'

export default {
  name: 'ActivityDetailModal',
  components: { ActivityRepeatForm, BaseModal, AppButtonSmRepeat, AppButtonSmEdit, AppCheckbox, AppConfirmation, AppSelect, AppButton, AppButtonSmRemove },
  props: {
    activity: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      reminder: {
        toggle: false,
        value: { id: null, name: 'Не выбрано' },
        options: [
          { id: 1, name: 'за 1 неделю' },
          { id: 2, name: 'за 1 день' },
          { id: 3, name: 'за 1 час' }
        ]
      },
      isVisibleModalRemove: false,
      isVisibleModalRepeat: false,

      repeatFormData: {
        start_time: this.activity.start_at,
        end_time: this.activity.end_at
      }
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    },
    isMember () {
      return this.activity.users.some(user => user.id === this.currentUser.id)
    }
  },
  methods: {
    deleteActivity (id) {
      this.isVisibleModalRemove = false
      this.isVisibleModalRepeat = false
      axios.delete(`${url}/activities/${id}/`, config).then(() => {
        this.$emit('close-modal')
        this.$store.dispatch('[user-calendar] initCalendar')
      })
    },
    closeModal () {
      this.$emit('close-modal')
    },
    formatDateTime (date) {
      return formatDateTime(date)
    },
    openUserDetail (userId) {
      this.$store.commit('[notification] CLOSE_DETAIL_EVENT_MODAL')
      this.$store.dispatch('closeNotificationWidget')
      this.$router.push({ path: `/user/info/${userId}/personal` })
    },
    editEvent () {
      const data = {
        itemableId: this.activity.id,
        type: 'Activity'
      }

      this.$emit('edit-event', data)
    },
    toggleIsVisibleModalRemove () {
      this.isVisibleModalRemove = !this.isVisibleModalRemove
    },
    toggleIsVisibleModalRepeat () {
      this.isVisibleModalRepeat = !this.isVisibleModalRepeat
    },

    // repeat
    activityRepeatSubmit (data) {
      data = {
        ...data
      }
      const activity_id = this.activity.id
      axios.post(`/activities/${activity_id}/repeat`, data, config)
        .then(() => { })
        .finally(() => { 
          this.isVisibleModalRepeat = false 
          // обновление данных на странице календаря, в профиле
          this.$store.commit('[user-calendar] SET_INITIAL_ACTIVITIES')
          this.$store.dispatch('[user-calendar] getActivities')
          this.closeModal()
        })
    }
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  overflow: auto;
}

.modal {
  max-width: 840px;

  .detail__head {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 67px;
    padding: 29px 40px 0;
    margin-bottom: 32px;

    .detail__head-title {
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0.04em;
      color: #0E619F;
    }

    .detail__head-close {
      cursor: pointer;

      &:hover {
        path {
          stroke: $color_second-light;
        }
      }
    }
  }

  &__body {
    position: relative;
  }
}

.event {
  width: 100%;
  padding-bottom: 60px;

  .margin {
    margin-bottom: 32px;
  }

  .event__block {
    display: flex;
    align-items: flex-start;

    .event__block-range {
      display: flex;
      background: #F3F5FF;
      padding: 30px;
      width: 100%;
      height: 108px;
      margin-right: 14px;

      .range__item:not(:last-child) {
        border-right: 1px solid #BCBCBC;
        padding-right: 40px;
        margin-right: 40px;
      }
    }
  }

  &__item-name {
    font-weight: bold;
    color: $font-color_second;
  }

  &__title {
    line-height: 1.15;
    color: $font_color_third;
    margin-top: 12px;
  }

  &__start {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    line-height: 1.15;
    margin-top: 10px;
    color: $font_color_second;
  }
}

.event__controls {
  //display: grid;
  //grid-template-columns: 1fr 1fr;
  //column-gap: 13px;

  .button-sm-delete {
    margin: 8px 0;
  }
}

.members-list {
  display: flex;
  flex-flow: row nowrap;
  margin-top: 14px;

  &__item {
    margin-right: 14px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.event-member-avatar {
  @include size(32px)
}

.event-group-avatar {
  @include size(32px);
  color: $font_color_alt;
}

.event-description {
  &__title {
    margin-bottom: 12px;
  }
}

.post__text {
  color: #697178;
}

.tooltip {
  position: relative;
  z-index: 999;
  cursor: pointer;
  left: -5px;

  &__right {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: auto;
    transition: all 0.2s;
    left: 50%;
    transform: translateX(-50%);
    right: auto;
    bottom: 50px;
    width: max-content;
    min-height: 50px;
    padding: 10px;
    color: $font_color_second;
    background-color: $color_main;
    border: 1px solid $border_color;
    border-radius: 3px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    //animation: fadeIn .3s ease-in;

    &:before {
      content: '';
      display: block;
      position: absolute;
      bottom: -6px;
      left: 50%;
      transform: translateX(-50%);
      margin: 0 auto;
      width: 10px;
      height: 10px;
      background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, $color_main 50%, $color_main 100%);
      border: 1px solid $border_color;
      border-bottom: none;
      border-right: none;
      transform: rotate(-135deg);
      box-shadow: 2px 2px 0 1px $color_main,
      -2px 0px 3px rgba(0, 0, 0, 0.25);
    }
  }

  &:hover {
    .tooltip__right {
      display: block;
    }
  }
}

.members-list__item{
  &:hover {
    .tooltip__block {
      opacity: 1;
      pointer-events: all;
    }
  }
}

.footer {
  max-width: 289px;

  .buttons {
    display: flex;
    margin-top: 32px
  }
}
</style>
